export const FLEX_START = 'flex-start';
export const FLEX_END = 'flex-end';
